import React from "react";
import "../css/Header.css";
import SearchIcon from "@material-ui/icons/Search";
import { Avatar } from "@material-ui/core";

import { useStateValue } from "../StateProvider";

import { Link } from "react-router-dom";
import HeaderSub from "./HeaderSub";

function Header() {
  const [{ user, userProfile }] = useStateValue();
  return (
    <div className="header">
      <div className="header__left">
        <h1>
          <Link to="/">_Space</Link>
        </h1>
        <div className="header__input">
          <SearchIcon />
          <input placeholder="Search" type="text" />
        </div>
      </div>

      <div className="header__right">
        <div className="header__info">
          <Avatar src={user.photoURL} />
          <h4>
            <Link to={`/profile/${userProfile && userProfile.username}`}>
              {userProfile && userProfile.name}
            </Link>
          </h4>
          <HeaderSub />
        </div>
      </div>
    </div>
  );
}

export default Header;
